<template>
  <VMultiModal :showing="showing">
    <EditorDeckModalsProjectSelector
      v-show="showing && step === AddThreeSixtySlideSteps.CHOOSE_PROJECT"
      :key="AddThreeSixtySlideSteps.CHOOSE_PROJECT"
      showing
      :project-id="state.projectId"
      :company-id="deck.company_id"
      data-testid="project-selector"
      @update:project-id="updateProjectId"
      @close="$emit('update:showing', false)"
    />
    <EditorDeckModalsSiteSelector
      v-show="showing && step === AddThreeSixtySlideSteps.CHOOSE_SITE"
      :key="`${state.projectId}-${AddThreeSixtySlideSteps.CHOOSE_SITE}`"
      showing
      :project-id="state.projectId"
      :current-item="state.sites"
      data-testid="site-selector"
      @close="$emit('update:showing', false)"
      @back="step = AddThreeSixtySlideSteps.CHOOSE_PROJECT"
      @choose-site="selectSite($event)"
    />
  </VMultiModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { reactive, ref, watch } from 'vue'

import type { Deck, IncludeCompany } from '@/entities/deck'
import type { Site } from '@/entities/site'
import type { EditDeck } from '@/composables/useEditDeck'
import { uvToCameraCoords } from '@/lib/site-viewer/utils'

enum AddThreeSixtySlideSteps {
  CHOOSE_PROJECT,
  CHOOSE_SITE,
}

const props = defineProps({
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['add-slide', 'error', 'update:showing'])

const step = ref<AddThreeSixtySlideSteps>(AddThreeSixtySlideSteps.CHOOSE_PROJECT)
const state = reactive({
  projectId: null as number | null,
  sites: [] as Site[],
})

watch(
  () => props.showing,
  async showing => {
    if (!showing) {
      state.projectId = null
      state.sites = []
      step.value = AddThreeSixtySlideSteps.CHOOSE_PROJECT
    }
  }
)

function updateProjectId(projectId: number) {
  state.projectId = projectId
  step.value = AddThreeSixtySlideSteps.CHOOSE_SITE
}

function selectSite(sites: Site[]) {
  if (sites.length === 0) return // shouldn't happen

  state.sites = sites

  if (!state.projectId) {
    throw new Error('Project or site are invalid.')
  }

  // Create the slide
  emit(
    'add-slide',
    state.sites.map(site => ({
      deck_id: props.deck.id,
      title: site.title,
      type: 'S',
      project_id: state.projectId,
      site_id: site.id,
      site_camera: uvToCameraCoords({
        x: site.initial_pan_x,
        y: site.initial_pan_y,
      }),
    }))
  )
}
</script>
